export default __webpack_public_path__ + "static/Graphik-Semibold-Web-9f35ea3ee3c886d404fdf0af0a8cdd50.woff";